/**
 * Odliczanie do końca aukcji dla każdej karty pojazdu
 * Zgodne z WCAG 2.1 - aktualizacje są oznaczone aria-live
 */

class AuctionCountdown {
    constructor(element) {
        this.element = element;
        this.endDate = new Date(element.dataset.auctionEnd);
        this.timerElement = element.querySelector('.auction-timer');

        if (!this.timerElement || isNaN(this.endDate.getTime())) {
            console.error('Invalid auction countdown element or date');
            return;
        }

        // Początkowe odliczanie
        this.update();

        // Aktualizacja co minutę (60000ms)
        this.interval = setInterval(() => this.update(), 60000);
    }

    update() {
        const now = new Date();
        const diff = this.endDate - now;

        if (diff <= 0) {
            this.timerElement.textContent = 'Aukcja zakończona';
            this.element.classList.add('auction-ended');
            clearInterval(this.interval);
            return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        // Format: "Xd Xh Xm"
        const parts = [];
        if (days > 0) parts.push(`${days}d`);
        if (hours > 0 || days > 0) parts.push(`${hours}h`);
        parts.push(`${minutes}m`);

        this.timerElement.textContent = parts.join(' ');
    }

    destroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
}

// Inicjalizacja wszystkich odliczeń na stronie
const initAuctionCountdowns = () => {
    const countdowns = document.querySelectorAll('.auction-countdown');

    if (!countdowns.length) {
        return;
    }

    countdowns.forEach(element => {
        new AuctionCountdown(element);
    });

    console.log(`Auction Countdown: Zainicjowano ${countdowns.length} odliczeń.`);
};

// Uruchom po załadowaniu strony
window.addEventListener('load', () => {
    setTimeout(initAuctionCountdowns, 500);
});

// Export dla potencjalnego użycia w innych skryptach
if (typeof module !== 'undefined' && module.exports) {
    module.exports = AuctionCountdown;
}

